import React from 'react';
import { Quote } from 'lucide-react';

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'Patrick McCain',
      role: 'SVP, Technical Portfolio Manager',
      company: 'Bank of America',
      image: 'PM',
      quote: 'Manikandan\'s expertise in Agile transformation and cloud migration was instrumental in our digital banking platform success. His ability to manage complex projects while maintaining team morale is exceptional.',
      rating: 5,
    },
    {
      name: 'Virinchi Ande',
      role: 'Data Scientist',
      company: 'Bank of America',
      image: 'VA',
      quote: 'Leading our $5M transformation from Waterfall to Agile, Manikandan achieved remarkable results - 30% velocity increase in just 6 months. His coaching and leadership skills are world-class.',
      rating: 5,
    },
    {
      name: 'Kapil Nesarikar',
      role: 'Manager',
      company: 'HPE',
      image: 'KN',
      quote: 'His deep understanding of cloud architecture and SAFe methodologies made our Azure migration seamless. Manikandan consistently delivers high-quality results while managing stakeholder expectations.',
      rating: 5,
    },
    {
      name: 'Deepak Kamath',
      role: 'Project Manager',
      company: 'M&T Bank',
      image: 'DK',
      quote: 'Manikandan\'s work on our digital banking transformation and PCI compliance was outstanding. His attention to detail and risk management expertise ensured we met all security requirements.',
      rating: 5,
    },
    {
      name: 'Dmitriy Borinsheteyn',
      role: 'Team Manager',
      company: 'Western Union',
      image: 'DB',
      quote: 'As a Product Owner managing 25+ engineers across multiple teams, Manikandan demonstrated exceptional leadership and strategic thinking. His KPI dashboards provided invaluable insights.',
      rating: 5,
    },
    {
      name: 'Joy Hall',
      role: 'Manager',
      company: 'Rackspace',
      image: 'JH',
      quote: 'The 25% improvement in sprint predictability under Manikandan\'s leadership was game-changing for our organization. His Agile coaching transformed our entire development approach.',
      rating: 5,
    },
    {
      name: 'Alan Bohannon',
      role: 'Director',
      company: 'USAA',
      image: 'AB',
      quote: 'Manikandan\'s strategic vision and execution capabilities are outstanding. His ability to align technology initiatives with business objectives made a significant impact on our digital transformation journey.',
      rating: 5,
    },
  ];

  return (
    <section id="testimonials" className="py-20 bg-white" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4" data-testid="testimonials-title">
            What People Say
          </h2>
          <div className="w-20 h-1 bg-blue-600 mx-auto"></div>
          <p className="mt-4 text-xl text-gray-600">Trusted by leaders across Fortune 500 companies</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-blue-50 to-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 p-8 relative"
              data-testid={`testimonial-card-${index}`}
            >
              {/* Quote Icon */}
              <div className="absolute top-6 right-6 text-blue-200">
                <Quote className="w-12 h-12" />
              </div>

              {/* Rating Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <svg
                    key={i}
                    className="w-5 h-5 text-yellow-400 fill-current"
                    viewBox="0 0 20 20"
                  >
                    <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                  </svg>
                ))}
              </div>

              {/* Quote */}
              <p className="text-gray-700 mb-6 leading-relaxed italic">
                "{testimonial.quote}"
              </p>

              {/* Author Info */}
              <div className="flex items-center gap-4 pt-6 border-t border-gray-200">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-600 to-blue-700 flex items-center justify-center text-white font-bold text-lg flex-shrink-0">
                  {testimonial.image}
                </div>
                <div>
                  <div className="font-semibold text-gray-900">{testimonial.name}</div>
                  <div className="text-sm text-gray-600">{testimonial.role}</div>
                  <div className="text-sm text-blue-600 font-medium">{testimonial.company}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;